// extracted by mini-css-extract-plugin
export default {"aboutBody":"About_aboutBody__2v3Xf","text":"About_text__oaEQB","img":"About_img__vfR0C","btn":"About_btn__8CC0U","divBtn":"About_divBtn__iWHT4"};